export const CREATE_USER_MUTATION = `
  mutation CreateUser($input: users_insert_input!) {
    insert_users_one(object: $input) {
      id
      first_name
      last_name
      email
      phone_number
      work_phone_number
      user_birthday
      address
      role
      work_start_date
      work_end_date
      annual_leave_balance
      company_id
      title_id
      team_id
      is_expense_manager
      is_loan_request_manager
      manages_collections
      created_at
      updated_at
      company {
        id
        name
      }
      title {
        id
        title_name
      }
      team {
        id
        name
      }
    }
  }
`;

export const UPDATE_USER_MUTATION = `
  mutation UpdateUser($id: Int!, $input: users_set_input!) {
    update_users_by_pk(pk_columns: { id: $id }, _set: $input) {
      id
      first_name
      last_name
      email
      phone_number
      work_phone_number
      user_birthday
      address
      role
      work_start_date
      work_end_date
      company_id
      is_expense_manager
      is_loan_request_manager
      manages_collections
      title_id
      team_id
      updated_at
      company {
        id
        name
      }
      title {
        id
        title_name
      }
      team {
        id
        name
      }
    }
  }
`;

export const DELETE_USER_MUTATION = `
  mutation DeleteUser($id: Int!) {
    delete_users_by_pk(id: $id) {
      id
    }
  }
`;

export const ADD_USER_TO_TEAM_MUTATION = `
  mutation AddUserToTeam($userId: Int!, $teamId: Int!) {
    update_users_by_pk(pk_columns: { id: $userId }, _set: { team_id: $teamId }) {
      id
      first_name
      last_name
      email
      team_id
    }
  }
`;

export const REMOVE_USER_FROM_TEAM_MUTATION = `
  mutation RemoveUserFromTeam($userId: Int!) {
    update_users_by_pk(pk_columns: { id: $userId }, _set: { team_id: null }) {
      id
      first_name
      last_name
      email
      team_id
    }
  }
`;

export const TRANSFER_USER_TO_TEAM_MUTATION = `
  mutation TransferUserToTeam($userId: Int!, $newTeamId: Int!, $transferDate: date!) {
    update_users_by_pk(
      pk_columns: { id: $userId }, 
      _set: { 
        team_id: $newTeamId,
        work_start_date: $transferDate
      }
    ) {
      id
      first_name
      last_name
      email
      team_id
      work_start_date
      team {
        id
        name
      }
    }
  }
`;

export const CHANGE_TEAM_MANAGER_MUTATION = `
  mutation ChangeTeamManager($teamId: Int!, $newManagerId: Int!, $oldManagerId: Int) {
    # Set old manager as team member (if exists)
    update_old_manager: update_users_by_pk(
      pk_columns: { id: $oldManagerId }, 
      _set: { team_id: $teamId }
    ) @skip(if: { eq: [$oldManagerId, null] }) {
      id
      first_name
      last_name
    }
    
    # Set new manager
    update_new_manager: update_users_by_pk(
      pk_columns: { id: $newManagerId }, 
      _set: { team_id: $teamId }
    ) {
      id
      first_name
      last_name
      team_id
    }
    
    # Update team's manager
    update_team: update_teams_by_pk(
      pk_columns: { id: $teamId }, 
      _set: { team_manager_id: $newManagerId }
    ) {
      id
      name
      team_manager_id
    }
  }
`;
